import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumGroupingOperation implements BaseEnumType {
  private static allValues: EnumGroupingOperation[] = []; // make sure this is top-most
  
  public static none = new EnumGroupingOperation(0, "None", "enum_grouping_operation_none");
  public static value = new EnumGroupingOperation(1, "Value", "enum_grouping_operation_value");
  public static year = new EnumGroupingOperation(2, "Year", "enum_grouping_operation_year");
  public static yearAndMonth = new EnumGroupingOperation(3, "YearAndMonth", "enum_grouping_operation_year_and_month");
  public static monthOfYear = new EnumGroupingOperation(4, "MonthOfYear", "enum_grouping_operation_month_of_year");
  public static dayOfWeek = new EnumGroupingOperation(5, "DayOfWeek", "enum_grouping_operation_day_of_week");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumGroupingOperation.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumGroupingOperation.none; }
  public isValue() { return this === EnumGroupingOperation.value; }
  public isYear() { return this === EnumGroupingOperation.year; }
  public isYearAndMonth() { return this === EnumGroupingOperation.yearAndMonth; }
  public isMonthOfYear() { return this === EnumGroupingOperation.monthOfYear; }
  public isDayOfWeek() { return this === EnumGroupingOperation.dayOfWeek; }

  public static getValues(): readonly EnumGroupingOperation[] {
    return EnumGroupingOperation.allValues;
  }

  public static getValuesExcept0(): readonly EnumGroupingOperation[] {
    return EnumGroupingOperation.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumGroupingOperation {
    const found = EnumGroupingOperation.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumGroupingOperation - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumGroupingOperation): EnumGroupingOperation {
    const found = name ? EnumGroupingOperation.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumGroupingOperation - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumGroupingOperation>): boolean {
    return this.key === other?.key;
  }
}